import { getActiveAccessToken } from '../GetAccess'

const addHeader = () => {
  const token = getActiveAccessToken()
  return new Headers({
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key': '5227def072844f18ae2d89f468d17c98',
    Authorization: 'Bearer ' + token
  })
}

export default addHeader
